export const SCREEN_FIELD = 'SCREEN_FIELD'
export const UNSCREEN_FIELD = 'UNSCREEN_FIELD'

export const screenField = field => ({ type: SCREEN_FIELD, field })
export const unScreenField = field => ({ type: UNSCREEN_FIELD, field })
